module.exports = __webpack_public_path__ + "images/rednotification.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rednotification.png
// module id = 2JNH
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13